module.exports = __webpack_public_path__ + "static/img/2.c29e2a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/youxiji/2.jpg
// module id = WjdZ
// module chunks = 1